/*
 * @Author: 张天昊
 * @Date: 2024-05-29 16:52:29
 * @LastEditTime: 2024-05-29 16:53:16
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/composables/useFixedElementHeight.js
 */
import { ref, onMounted, nextTick } from 'vue';
export function useFixedElementHeight(initial = true) {
  const el = ref(null);
  const height = ref('0');
  onMounted(() => {
    initial && updateHeight();
  });
  function updateHeight() {
    nextTick(() => {
      if (el.value) height.value = window.getComputedStyle(el.value).height;
    });
  }

  return {
    el,
    height,
    updateHeight
  };
}
